<i18n src='../common_locales.yaml'></i18n>

<i18n>
en:
  sub_amount: "Sub-amount"
  delivery_fee: "Delivery fee"
  total: "Total (excl. tax)"
  view_cart: "View Cart"
  no_item_in_cart: "No item in your cart"
  your_cart_is_empty: "Your cart is empty"
  set_location : "Set location"
  checkout: "Checkout"
  enter_postcode: "Enter postcode"
  save: "Save"
  change: "Change"
  hot_pickup: "Hot Pickup"
  hot_delivery: "Hot Delivery"
  frozen_delivery: "Frozen Delivery"
ja:
  sub_amount: "サブ金額"
  delivery_fee: "配送料"
  total: "税抜合計"
  view_cart: "カート"
  your_cart_is_empty: "あなたのカートは空です"
  no_item_in_cart: "あなたのカートには何もありません"
  set_location: "セット ロケーション"
  checkout: "チェックアウト"
  enter_postcode: "郵便番号"
  save: "セーブ"
  change: "変化する"
  hot_pickup: "取り除く"
  hot_delivery: "出来立て配送"
  frozen_delivery: "クール便発送"
</i18n>

<template lang="pug">
transition(:duration="{leave: 0}" :enter-active-class="animation")
  .dropdown-menu.show.cart-dropdown.p-3.dropdown-menu-right
    div(v-if="cartItems.length === 0")
      p.mb-0 {{$t('your_cart_is_empty')}}
    div(v-else)
      .cart-items
        a.link-restaurant(@click.stop="clickRestaurant(restaurantUrl)")
          p {{ localeRestaurantName }} ({{$t(orderDeliveryType)}})
        table.table
          tbody
            cart-item(v-for="(item, index) in cartItems" :item="item" :index="index" :key="item.id")
        .total-amount
          template(v-if="orderDeliveryType === 'hot_delivery' || orderDeliveryType === 'frozen_delivery'")
            div.row-sub-amount {{$t('sub_amount')}}
              span.text-sub-amount ¥ {{ subAmount }}
            //- div.row-sub-amount
              span(v-if="!orderPostcode") {{$t('delivery_fee')}}
              span(v-if="orderPostcode && !enterPostcodeActive") {{$t('delivery')}} to {{orderPostcode.area_en}}, {{orderPostcode.prefecture_en}}
                |  (
                a.text-primary(@click.stop="enterPostcodeActive = true") {{$t('change')}}
                | )
              span.text-sub-amount(v-if="orderPostcode && !enterPostcodeActive") {{ deliveryAmount > 0 ? '¥ ' + deliveryAmount : 'Free' }}
              span.text-sub-amount(v-if="!orderPostcode || enterPostcodeActive")
                a.text-sub-amount.text-primary(v-if="!enterPostcodeActive" @click.stop="enterPostcodeActive = true") {{$t('set_location')}}
                template(v-if="enterPostcodeActive")
                  .input-group
                    input.form-control.form-control-sm(type="text" :placeholder="$t('enter_postcode')" v-model="postcode" @keyup.enter="clickSetPostcode")
                    span.input-group-btn
                      button.btn.btn-primary.btn-sm(@click.stop="clickSetPostcode") {{$t('save')}}
                  small.text-danger(v-if="postcodeErrorMessage") {{postcodeErrorMessage}}
                  
              br(v-if="enterPostcodeActive")
              br(v-if="enterPostcodeActive")
              br(v-if="enterPostcodeActive")
          div.row-total {{$t('total')}}
            span.text-total-amount ¥ {{ totalAmount }}
      .dropdown-divider
      .buttons
        button.btn.btn-secondary.btn-block(@click.stop="clickViewCart") {{$t('view_cart')}}
        button.btn.btn-primary.btn-block(@click.stop="clickCheckOut") {{$t('checkout')}}
</template>

<script>
import Vue from 'vue'
import CartItem from './CartItem.vue'
import { mapGetters, mapActions } from 'vuex'
import api from '../api'
import DeliveryAddressForm from '../components/DeliveryAddressForm.vue'

export default {
  name: 'cart-dropdown',
  props: {
    attention: {
      default: false
    }
  },
  data () {
    return {
      enterPostcodeActive: false,
      postcodeErrorMessage: null,
      postcode: '',
      postcodeEventBus: new Vue(),
      animation: this.attention ? 'animated pulse fast' : ''
    }
  },
  components: {
    CartItem,
    DeliveryAddressForm
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      loggedIn: 'isLoggedIn',
      cartItems: 'getCartItems',
      cartRestaurant: 'getCartRestaurant',
      orderDeliveryType: 'getOrderDeliveryType',
      orderPostcode: 'getOrderPostcode',
      subAmount: 'getCartSubAmount',
      deliveryAmount: 'getCartDeliveryAmount',
      totalAmount: 'getCartTotalAmount'
    }),
    restaurantUrl () {
      return '/restaurant/' + this.cartRestaurant.slug + '/' + this.cartRestaurant.public_ident
    },
    localeRestaurantName () {
      return this.cartRestaurant['name_' + this.$i18n.locale]
    }
    // deliveryTypeDisplay () {
    //   const display = {
    //     'hot_pickup': 'Self Pickup',
    //     'hot_delivery': 'Hot Delivery',
    //     'frozen_delivery': 'Frozen Delivery'
    //   }
    //   return display[this.orderDeliveryType]
    // }
  },
  mounted () {
    if (this.orderPostcode) {
      this.postcode = this.orderPostcode.postcode
    }
  },
  created () {
    this.postcodeEventBus.$on('updated', postcode => {
      this.postcode = postcode
      // this.fillBillingAddress()
    })
  },
  methods: {
    ...mapActions(['setOrderPostcode']),
    clickViewCart (e) {
      this.dismissDropdown()
      this.$router.push('/cart')
    },
    openPostcodePicker () {
      this.$modal.open('postcode-picker', {eventbus: this.postcodeEventBus, autoclose: false, validateDelivery: false})
    },
    clickCheckOut (e) {
      this.dismissDropdown()
      if (this.loggedIn) {
        this.$router.push('/checkout')
      } else {
        this.$modal.open('login', {next: '/checkout'})
      }
    },
    clickRestaurant (restaurantUrl) {
      this.dismissDropdown()
      this.$router.push(String(restaurantUrl))
    },
    dismissDropdown () {
      this.$modal.close()
    },
    clickSetPostcode () {
      if (this.postcode.replace('-', '').length !== 7) {
        this.postcodeErrorMessage = 'Please enter valid postcode'
        return
      }
      api.get(`/postcodes/${this.postcode.replace('-', '')}/?restaurant_public_id=${this.cartRestaurant.public_ident}`)
      .then(response => {
        if (response.data.hot_delivery_supported) {
          this.setOrderPostcode(response.data)
          this.enterPostcodeActive = false
          this.postcodeErrorMessage = null
        } else {
          this.postcodeErrorMessage = 'Cannot deliver to this location'
        }
      })
      .catch(e => {
        console.log(e)
        this.postcodeErrorMessage = 'Please enter valid postcode'
      })
    },
    clickPostcodeFinder () {
      this.$modal.open('postcode-picker', {eventbus: this.postcodeEventBus, autoclose: false})
    }
  }
}
</script>

<style lang="scss" scoped>
.cart-dropdown {
  width: 390px;
  @media(max-width:575px){
    max-width: 95vw;
  }
  .row-total {
    font-weight: 700;
  }
}

.cart-items {
  font-size: 0.875rem;
  a {
    color: #000;
    font-weight: 500;
  }
}

.fast {
  animation-duration : 0.3s;
}

</style>





// WEBPACK FOOTER //
// src/components/CartDropdown.vue